import { IGraphqlMapper } from '../../models/interfaces/I-graphql-mapper';

export class DeleteMutationMapper implements IGraphqlMapper {
  returnFromJson(json: any): any {
    return json as boolean;
  }
}
